<script setup lang="ts"></script>
<template>
  <div class="mx-auto max-w-7xl px-6 lg:px-12">
    <slot />
  </div>
</template>
